import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

import Img from "gatsby-image"
import ArrowRight from "../../../images/arrow-right.svg"
import { useTranslateValue } from "../../../data/TranslateContext"

export default function MilkshakeMintChipCup(props) {
  const images = useStaticQuery(graphql`
    query cupImageMilkshakeMintChipCup {
      cupImageLarge: file(
        relativePath: { eq: "front-page-flavors/milkshake-mint-chip-can.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 320) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cupImageMedium: file(
        relativePath: { eq: "front-page-flavors/milkshake-mint-chip-can.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 260) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cupImageSmall: file(
        relativePath: { eq: "front-page-flavors/milkshake-mint-chip-can.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 180) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const cupSources = [
    images.cupImageLarge.childImageSharp.fluid,
    {
      ...images.cupImageMedium.childImageSharp.fluid,
      media: `(max-width: 768px)`,
    },
    {
      ...images.cupImageSmall.childImageSharp.fluid,
      media: `(max-width: 540px)`,
    },
  ]

  const [{ language }] = useTranslateValue()

  return (
    <>
      <Img fluid={cupSources} />
      <div className="flavor-label">
        {language === "en" && <h2>Mint Chip</h2>}
        {language === "fr" && <h2>Brisures et Menthe</h2>}

        <Link to="/flavors" state={{ flavor: "milkshakeCoolMintChip" }}>
          {language === "en" && "Check out the details"}
          {language === "fr" && "Consultez les détails"}
          <ArrowRight />
        </Link>
      </div>
    </>
  )
}

const Svg = styled.svg`
  .active-bg-1 {
    transition: all 0.2s ease-in-out;
    opacity: ${props => (props.active ? 1 : 0)};
  }

  .border {
    transition: all 0.2s ease-in-out;
    fill: ${props => (props.active ? "#228282" : props.theme.color.primary)};
  }
`
export function MilkshakeMintChipThumb(props) {
  const { active } = props

  return (
    <>
      {/* Mint Leaf */}
      <Svg
        version="1.1"
        viewBox="0 0 146 146"
        xmlns="http://www.w3.org/2000/svg"
        active={active}
      >
        <path
          className="active-bg-1"
          d="m50.81 82.971c0.27095 11.865 10.489 21.349 23 21.349s22.729-9.4843 23-21.349c0-15.159-18.732-38.26-23.059-42.651-4.5968 4.3705-22.941 27.717-22.941 42.651z"
          fill="#C8E6D7"
        />
        <path
          className="border"
          d="m73.54 37.85 0.17653 0.0037566 0.14722 0.018152c0.58661 0.11198 1.4908 0.79627 4.8362 4.9781l0.35158 0.44796c1.8699 2.4066 4.5679 6.2413 8.0938 11.504 5.0223 7.9994 10.715 19.109 10.715 28.158-0.25786 12.714-10.239 22.987-22.759 23.778l-5.853e-4 9.9821c0.010796 0.40471-0.14246 0.7966-0.42494 1.0866-0.28248 0.29002-0.6702 0.45339-1.0751 0.45339-0.82843 0-1.5-0.67157-1.5-1.5l2.099e-4 -10.015c-12.572-0.7372-22.612-11.033-22.87-23.785 0-9.2782 5.8513-20.629 10.872-28.61l0.92675-1.384c6.7822-10.077 10.953-15.116 12.511-15.116zm-0.1 3.47-0.27065 0.27823-0.29353 0.3146c-5.0156 5.4708-20.696 27.065-20.696 41.077 0.031731 11.282 8.8187 20.5 19.92 21.224l-2.377e-4 -6.6621-10.22-10.872c-0.45911-0.37098-0.65797-0.97672-0.50808-1.5476 0.14989-0.57091 0.62066-1.0008 1.2028-1.0984 0.58213-0.097603 1.1674 0.15527 1.4953 0.64607l8.03 8.481v-17.139l-6.26-6.672c-0.57714-0.59647-0.56147-1.5479 0.035-2.125s1.5479-0.56147 2.125 0.035l4.1 4.37v-20.22c0-0.82843 0.67157-1.5 1.5-1.5s1.5 0.67157 1.5 1.5v20.381l4.18-4.171c0.27993-0.28337 0.66168-0.44286 1.06-0.44286s0.78007 0.15949 1.06 0.44286c0.57946 0.58788 0.57946 1.5321 0 2.12l-6.3 6.374v17.334l8.18-8.188c0.27993-0.28337 0.66168-0.44286 1.06-0.44286s0.78007 0.15949 1.06 0.44286c0.57946 0.58788 0.57946 1.5321 0 2.12l-10.3 10.279 5.808e-4 6.5396c10.884-0.82248 19.491-9.8085 19.705-20.857l0.0039966-0.35184c0-14.81-17.37-37.38-21.37-41.67zm24.12 13.42c1.215 0 2.2 0.98497 2.2 2.2s-0.98497 2.2-2.2 2.2-2.2-0.98497-2.2-2.2 0.98497-2.2 2.2-2.2zm-48.88-1.15c1.4801 0 2.68 1.1999 2.68 2.68s-1.1999 2.68-2.68 2.68-2.68-1.1999-2.68-2.68 1.1999-2.68 2.68-2.68zm7.35-7.27c1.3697 0 2.48 1.1103 2.48 2.48s-1.1103 2.48-2.48 2.48-2.48-1.1103-2.48-2.48 1.1103-2.48 2.48-2.48zm35.43-4.17c1.9717 0 3.57 1.5983 3.57 3.57s-1.5983 3.57-3.57 3.57-3.57-1.5983-3.57-3.57 1.5983-3.57 3.57-3.57zm-42.07-2.07c1.0825 0 1.96 0.87752 1.96 1.96s-0.87752 1.96-1.96 1.96-1.96-0.87752-1.96-1.96 0.87752-1.96 1.96-1.96zm10.85-7.21c2.0048 0 3.63 1.6252 3.63 3.63s-1.6252 3.63-3.63 3.63-3.63-1.6252-3.63-3.63 1.6252-3.63 3.63-3.63zm23.53 3.02c1.0107 0 1.83 0.81932 1.83 1.83s-0.81932 1.83-1.83 1.83-1.83-0.81932-1.83-1.83 0.81932-1.83 1.83-1.83zm12.8-5.03c1.4801 0 2.68 1.1999 2.68 2.68s-1.1999 2.68-2.68 2.68-2.68-1.1999-2.68-2.68 1.1999-2.68 2.68-2.68zm-23.11-3.86c1.4801 0 2.68 1.1999 2.68 2.68s-1.1999 2.68-2.68 2.68-2.68-1.1999-2.68-2.68 1.1999-2.68 2.68-2.68z"
          fill="#228282"
        />
      </Svg>
    </>
  )
}
